import { render, staticRenderFns } from "./DialogDetailGroupOnePlatform.vue?vue&type=template&id=0ea9b3a5&"
import script from "./DialogDetailGroupOnePlatform.vue?vue&type=script&lang=js&"
export * from "./DialogDetailGroupOnePlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports